import React from "react";
import { useLocale } from "../i18n";
import SEO, { buildBreadcrumb } from "../components/SEO";
import { Mail, MessagesSquare, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Contact() {
  const { locale } = useLocale();
  const en = locale === "en";

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: en ? "Contact WowRomania" : "Contactează WowRomania",
      url: "https://wowromania.com/contact",
      inLanguage: en ? "en" : "ro",
    },
    buildBreadcrumb([
      { name: en ? "Home" : "Acasă", path: "/" },
      { name: en ? "Contact" : "Contact", path: "/contact" },
    ]),
  ];

  return (
    <>
      <SEO
        title={en ? "Contact" : "Contact"}
        description={en
          ? "Reach out about editorial ideas, partnerships, corrections, press or privacy. We respond within a few working days."
          : "Scrie-ne despre idei editoriale, parteneriate, corecturi, presă sau confidențialitate. Răspundem în câteva zile lucrătoare."}
        path="/contact"
        jsonLd={jsonLd}
      />
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-16 lg:py-24" data-testid="contact-page">
        <p className="font-mono-wr text-[11px] uppercase tracking-[0.3em] text-[var(--wr-red)] mb-4">
          / {en ? "CONTACT" : "CONTACT"}
        </p>
        <h1 className="font-editorial text-5xl sm:text-6xl lg:text-8xl leading-[0.95] tracking-tight text-[var(--wr-ink)] mb-8" data-testid="contact-heading">
          {en ? "Say hello." : "Salutare."}
        </h1>
        <p className="text-[18px] leading-relaxed text-[var(--wr-ink-2)] max-w-2xl mb-16">
          {en
            ? "For editorial ideas, partnerships, corrections, press or privacy — email is the fastest way. We read every message and reply within a few working days."
            : "Pentru idei editoriale, parteneriate, corecturi, presă sau confidențialitate — cel mai rapid e email-ul. Citim fiecare mesaj și răspundem în câteva zile lucrătoare."}
        </p>

        <div className="grid md:grid-cols-2 gap-4 max-w-2xl">
          <a
            href="mailto:contact.wowromania@gmail.com"
            className="wr-sharp-card p-8 group flex flex-col justify-between min-h-[220px] hover:-translate-y-1 transition-transform"
            data-testid="contact-general"
          >
            <div className="flex items-start justify-between">
              <Mail size={22} className="text-[var(--wr-red)]" />
              <ArrowUpRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
            <div>
              <p className="font-mono-wr text-[10px] uppercase tracking-widest text-[var(--wr-ink-2)] mb-2">
                {en ? "General" : "General"}
              </p>
              <h3 className="font-editorial text-3xl leading-none tracking-tight text-[var(--wr-ink)] mb-2">
                contact.wowromania@<br/>gmail.com
              </h3>
              <p className="text-[13px] text-[var(--wr-ink-2)] leading-snug">
                {en ? "Ideas, corrections, partnerships." : "Idei, corecturi, parteneriate."}
              </p>
            </div>
          </a>

          <a
            href="mailto:contact.wowromania@gmail.com"
            className="wr-sharp-card p-8 group flex flex-col justify-between min-h-[220px] hover:-translate-y-1 transition-transform"
            data-testid="contact-privacy"
          >
            <div className="flex items-start justify-between">
              <Mail size={22} className="text-[var(--wr-red)]" />
              <ArrowUpRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
            <div>
              <p className="font-mono-wr text-[10px] uppercase tracking-widest text-[var(--wr-ink-2)] mb-2">
                {en ? "Privacy" : "Confidențialitate"}
              </p>
              <h3 className="font-editorial text-3xl leading-none tracking-tight text-[var(--wr-ink)] mb-2">
                contact.wowromania@<br/>gmail.com
              </h3>
              <p className="text-[13px] text-[var(--wr-ink-2)] leading-snug">
                {en ? "Data-subject rights, GDPR." : "Drepturi GDPR, date personale."}
              </p>
            </div>
          </a>
        </div>

        <div className="mt-16 pt-12 border-t border-[var(--wr-border)] max-w-2xl">
          <p className="font-mono-wr text-[10px] uppercase tracking-[0.2em] text-[var(--wr-ink-2)] mb-3">
            {en ? "Or ask the Concierge" : "Sau întreabă Ghidul"}
          </p>
          <p className="text-[16px] leading-relaxed text-[var(--wr-ink)] mb-5">
            {en
              ? "For a specific travel question, the AI Concierge is often faster than email."
              : "Pentru o întrebare specifică de călătorie, Ghidul AI e adesea mai rapid decât un email."}
          </p>
          <Link
            to="/concierge"
            className="inline-flex items-center gap-2 px-5 py-3 bg-[var(--wr-ink)] text-[var(--wr-bg)] hover:bg-[var(--wr-red)] transition-colors font-mono-wr text-[11px] uppercase tracking-[0.2em]"
            data-testid="contact-cta-concierge"
          >
            <MessagesSquare size={14} />
            {en ? "Open the Concierge" : "Deschide Ghidul"}
            <ArrowUpRight size={14} />
          </Link>
        </div>
      </div>
    </>
  );
}
